export const OFFICE_NOTIFICATION_INTENT_KEY = 'zia_open_office_notification';
export type OfficeNotificationIntent = 'payroll' | 'businessSeats' | 'training' | 'certs';

/** Keep taps queued through sign-in/access resolution, then open existing screens. */
export function consumeOfficeNotificationIntent(handlers: {
  ready: boolean;
  open: (destination: OfficeNotificationIntent) => boolean | void;
}, storage: Pick<Storage,'getItem'|'removeItem'> = sessionStorage): boolean {
  if (!handlers.ready) return false;
  try {
    const value=storage.getItem(OFFICE_NOTIFICATION_INTENT_KEY);
    if (!value) return false;
    if (!['payroll','businessSeats','training','certs'].includes(value)) {
      storage.removeItem(OFFICE_NOTIFICATION_INTENT_KEY);return false;
    }
    if (handlers.open(value as OfficeNotificationIntent) === false) return false;
    storage.removeItem(OFFICE_NOTIFICATION_INTENT_KEY);
    return true;
  } catch { return false; }
}
